import React from 'react'
import { NavLink } from 'react-router-dom'

const MenuLinks = ({styles}) => {

  const isActiveStyle = 'border-b-2 mx-3 border-white font-extrabold transaction-all duration-200 ease-in-out hover:shadow-xl py-1'
  const isNotActiveStyle = 'pl-3 hover:font-extrabold transaction-all duration-200 ease-in-out capitalize hover:shadow-xl py-1'
  
  const links = [
    { name: "Home", id: ""}, 
    { name: "About Us", id: "about"},
    { name: "Courses", id: "courses",},
    { name: "Partners", id: "partners",},
    { name: "Contact Us", id: "contactUs",}
  ]
 
  return (
    <div className={styles}>
      {
        links.map(category => 
              ( 
                <NavLink 
                  to={`${category.id}`}
                  className={({isActive}) => isActive ? isActiveStyle : isNotActiveStyle}
                  key={category.name}
                >
                  {category.name}
                </NavLink>
              )
            )
      }
    </div>
  )
}

export default MenuLinks
